(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-angle-viewer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-angle-viewer]').forEach(function (root) {
      var frames = Array.prototype.slice.call(root.querySelectorAll('[data-frame]'));
      if (frames.length < 2) return;
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var spin = root.querySelector('[data-spin]');
      var i = 0, timer = null, touched = false;
      var speed = parseInt(root.getAttribute('data-speed'), 10) || 2200;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var dragOn = root.getAttribute('data-drag') === 'true';

      function show(n) {
        var spinIdx = spin ? -1 : 0;
        if (spin && n === -1) {
          spin.classList.add('is-active');
          frames.forEach(function (f) { f.classList.remove('is-active'); });
          thumbs.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-thumb') === '-1'); });
          i = 0;
          return;
        }
        if (spin) spin.classList.remove('is-active');
        i = (n - (spin ? 0 : 0) + frames.length) % frames.length;
        frames.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-thumb') === String(i)); });
      }
      function next() { show(i + 1); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var start = function () { stop(); timer = setInterval(next, speed); };
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (touched) return; e.isIntersecting ? start() : stop(); });
          }, { threshold: 0.35 }).observe(root);
        } else { start(); }
      }

      thumbs.forEach(function (b) {
        b.addEventListener('click', function () { touched = true; stop(); show(parseInt(b.getAttribute('data-thumb'), 10)); });
      });

      if (dragOn) {
        var x0 = null;
        root.addEventListener('pointerdown', function (e) { x0 = e.clientX; touched = true; stop(); });
        root.addEventListener('pointerup', function (e) {
          if (x0 === null) return;
          var d = e.clientX - x0; x0 = null;
          if (Math.abs(d) < 18) return;
          show(d < 0 ? i + 1 : i - 1);
        });
        root.addEventListener('pointercancel', function () { x0 = null; });
        root.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { touched = true; stop(); show(i + 1); }
          if (e.key === 'ArrowLeft') { touched = true; stop(); show(i - 1); }
        });
        root.tabIndex = 0;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-tshdr-burger]');
    var drawer = document.querySelector('[data-tshdr-drawer]');
    if (!btn || !drawer) return;
    btn.addEventListener('click', function () {
      var open = drawer.hasAttribute('hidden');
      if (open) { drawer.removeAttribute('hidden'); } else { drawer.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();

  /* Header must scroll away with the page: it never follows the scroll and never overlaps
     the content below the hero. The header is an overlay (absolute) inside the theme's own
     scroll container, so it is moved up by the exact scroll offset — behaving as if it were
     part of the normal page flow (header stays up, content scrolls under it). */
  (function () {
    var wrap = document.querySelector('.ts-header-wrapper');
    if (!wrap) return;
    if (getComputedStyle(wrap).position !== 'absolute') return;
    var bar = wrap.querySelector('.tshdr') || wrap;
    var scroller = null, el = wrap.parentElement;
    while (el && el !== document.body) {
      var cs = getComputedStyle(el);
      if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 20) { scroller = el; break; }
      el = el.parentElement;
    }
    var raf = null;
    function apply() {
      raf = null;
      var y = scroller ? (scroller.scrollTop || 0) : 0;
      var dse = document.scrollingElement || document.documentElement;
      y = Math.max(y, dse.scrollTop || 0, document.body.scrollTop || 0, window.pageYOffset || 0);
      var h = bar.offsetHeight || 0;
      var t = Math.min(Math.max(y, 0), h);
      if (t > 0) {
        wrap.style.transform = 'translate3d(0,' + (-t) + 'px,0)';
        wrap.style.visibility = (t >= h) ? 'hidden' : '';
      } else {
        wrap.style.transform = '';
        wrap.style.visibility = '';
      }
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(apply); }
    var target = scroller || window;
    target.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  })();

  } catch(e) { console.error(e); }
})();
})();
